import React, { useEffect, useState } from "react";
import Sidebar from "../Sidebar/Sidebar";
import Topbar from "../Topbar/Topbar";
import "../../Modules/Tickets/Ticketslist.css";
import "react-datepicker/dist/react-datepicker.css";
import img from "../../Assets/png/img.png";
import project_based_tic from "../../Assets/svg/project_based_tic.svg";
import component_ticket_ic from "../../Assets/svg/component_ticket_ic.svg";
import customer_ic from "../../Assets/svg/customer_ic.svg";
import vendor_ticker_ic from "../../Assets/svg/vendor_ticker_ic.svg";
import priorty_ticket_ic from "../../Assets/svg/priorty_ticket_ic.svg";
import expected_ticket_ic from "../../Assets/svg/expected_ticket_ic.svg";
import created_ticket_ic from "../../Assets/svg/created_ticket_ic.svg";
import region_ticket_ic from "../../Assets/svg/region_ticket_ic.svg";
import unallocated_ticket_ic from "../../Assets/svg/unallocated_ticket_ic.svg";
import open_ticket_ic from "../../Assets/svg/open_ticket_ic.svg";
import inprogress_ticket_ic from "../../Assets/svg/inprogress_ticket_ic.svg";
import hold_ticket_ic from "../../Assets/svg/hold_ticket_ic.svg";
import closed_ticker_ic from "../../Assets/svg/closed_ticker_ic.svg";
import completed_ticket_ic from "../../Assets/svg/completed_ticket_ic.svg";
import approval_based_ic from "../../Assets/svg/approval_based_ic.svg";
import team_baed_ic from "../../Assets/svg/team_baed_ic.svg";
import status_based_ic from "../../Assets/svg/status_based_ic.svg";
import monthly_ticket_ic from "../../Assets/svg/monthly_ticket_ic.svg";
import weekly_ticket_ic from "../../Assets/svg/weekly_ticket_ic.svg";
import reporter_based_ic from "../../Assets/svg/reporter_based_ic.svg";
import location_icon_9c from "../../Assets/svg/location_icon_9c.svg";
import MonthlyIc from "../../assets-1/svg/monthly_ic.svg";
import WeeklIc from "../../assets-1/svg/weekly-ic.svg";
import TargetIc from "../../assets-1/svg/target-ic.svg";
import GrouperIc from "../../assets-1/svg/group_per_ic.svg";
import PersonwitTick from "../../assets-1/svg/per_witTick.svg";
import locIc from "../../assets-1/svg/loc_ic.svg";

import personIc from "../../assets-1/svg/person_ic.svg";
import grpPersonIc from "../../assets-1/svg/group_per_ic.svg";
import statusbaseIc from "../../assets-1/svg/status_base_ic.svg";
import { ReactComponent as SlotCloseIcon } from "../../Assets/svg/close-modal.svg";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import MultiSelectDropDown from "../common/searchbox/multi-select-dropdown.js";
import "./report.css";
import DatePicker from "react-datepicker";
import {
  downloadBase64File,
  exportquickApi,
  getquickreportApi,
} from "./report-api.js";
import { red } from "@mui/material/colors";
import { Dropdown, DropdownButton } from "react-bootstrap";
import { useGlobal } from "../../GlobalContext.js";
import { useUI } from "../../UIContext";
import { apiCall, apiCallAdmin } from "../../services/api-service.js";

const Ticketlist = ({}) => {
  const { isCollapsed } = useUI();
  const apiUrl = process.env.REACT_APP_API_URL;
  const accountsUrl = process.env.REACT_APP_ADMIN_API_URL;
  const [projectlist, setProjectlist] = useState([
    { value: "", label: "Choose" },
  ]);
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];
  const assignedList = [
    { label: "Assigned", value: "assigned" },
    { label: "Unassigned", value: "un_assigned" },
  ];
  const approvalList = [
    { label: "Approved", value: "Approved" },
    { label: "Pending", value: "Pending" },
    { label: "Rejected", value: "Rejected" },
  ];
  const reportTypes = [
    // "Created",
    { label: "Ticket", value: "tickets" },
    { label: "Assigned to me", value: "assigned_me" },
    { label: "My tickets", value: "my_tickets" },
    { label: "User Closed", value: "closed" },
    { label: "Assign to my team", value: "assigned_to_team" },
    { label: "Approval in report type", value: "approval" },
  ];
  const filterTypes = [
    {
      label: "Except description and comment",
      value: "except_description_and_comment",
    },
    { label: "Except description", value: "except_description" },
    { label: "Except comment", value: "except_comment" },
    { label: "With description and comment", value: "" },
  ];
  const [selectedProjectOptions, setSelectedProjectOptions] = useState([]);
  const [selectedTeamOptions, setSelectedTeamOptions] = useState([]);
  const [selectedComponentOptions, setSelectedComponentOptions] = useState([]);
  const [selectedPriorityOptions, setSelectedPriorityOptions] = useState([]);
  const [selectedAssigneeOptions, setSelectedAssigneeOptions] = useState([]);
  const [selectedStatusOptions, setSelectedStatusOptions] = useState([]);
  const [selectedApprovalStatusOptions, setSelectedApprovalStatusOptions] =
    useState([]);
  const [selectedCustomerOptions, setSelectedCustomerOptions] = useState([]);
  const [selectedVendorOptions, setSelectedVendorOptions] = useState([]);
  const [quickReportList, setQuickReportList] = useState([]);
  const [selectedReportType, setSelectedReportType] = useState("QuickReport");
  const [selectedType, setSelectedType] = useState("All");
  const [statusList, setStatusList] = useState([
    { label: "Open", value: "Open" },
    { label: "In Progress", value: "In Progress" },
    { label: "Hold", value: "Hold" },
    { label: "Closed", value: "Closed" },
    { label: "Completed", value: "Completed" },
  ]);
  const [priorityList, setPriorityList] = useState([
    { label: "Low", value: "Low" },
    { label: "Medium", value: "Medium" },
    { label: "High", value: "High" },
  ]);

  const [reportStartDate, setReportStartDate] = useState(null);
  const [reportEndDate, setReportEndDate] = useState(null);

  const [formattedFromDate, setFormattedFromDate] = useState("");
  const [formattedToDate, setFormattedToDate] = useState("");

  const [modulelist, setModulelist] = useState([]);
  const [componentlist, setComponentlist] = useState([]);
  const [subcomponentlist, setSubcomponentlist] = useState([]);
  const [teamlist, setTeamlist] = useState([]);
  const [emplist, setEmplist] = useState([]);
  const [excel, setExcel] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isCustomerChecked, setIsCustomerChecked] = useState(false);
  const [isVendorChecked, setIsVendorChecked] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  // report page check box
  const handleCustomerCheckBox = (e) => {
    if (e.target) {
      setIsCustomerChecked(e.target.checked);
    }
  };
  const handleVendorCheckBox = (e) => {
    if (e.target) {
      setIsVendorChecked(e.target.checked);
    }
  };

  const handleCheckboxChange = (e) => {
    // Check if the target element is available before accessing its value
    if (e.target) {
      setIsChecked(e.target.checked);
    }
  };
  const handleDatesChange = (dates) => {
    const [start, end] = dates;
    setReportStartDate(start);
    setReportEndDate(end);

    if (start) {
      setFormattedFromDate(formatDate(start));
    }
    if (end) {
      setFormattedToDate(formatDate(end));
    }
  };
  const handleDateClear = () => {
    setReportStartDate(null);
    setReportEndDate(null);
    setFormattedFromDate("");
    setFormattedToDate("");
  };
  const formatDate = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getIconByLabel = (label) => {
    switch (label) {
      case "Monthly Report":
        return monthly_ticket_ic;
      case "Weekly Report":
        return weekly_ticket_ic;
      case "Approval tickets":
        return approval_based_ic;
      case "Region Based":
        return region_ticket_ic;
      case "Location Based":
        return location_icon_9c;
      case "Status Based":
        return status_based_ic;
      case "Team Based":
        return team_baed_ic;
      case "Reporter Based":
      case "Assignee Based":
        return reporter_based_ic;

      case "Project Based":
        return project_based_tic;
      case "Component Based":
        return component_ticket_ic;
      case "Priority Based":
        return priorty_ticket_ic;
      case "Expected date Based":
        return expected_ticket_ic;
      case "Created date Based":
        return created_ticket_ic;
      case "Customer Based":
        return customer_ic;
      case "Vendor Based":
        return vendor_ticker_ic;
      case "Unallocated":
        return unallocated_ticket_ic;
      case "Open tickets":
        return open_ticket_ic;
      case "In progress tickets":
        return inprogress_ticket_ic;
      case "Hold tickets":
        return hold_ticket_ic;

      case "Closed tickets":
        return closed_ticker_ic;
      case "Completed tickets":
        return completed_ticket_ic;

      default:
        return project_based_tic;
    }
  };
  const handleReset = () => {
    setSelectedType("All");
    document.getElementById("report_type").value = "";
    setSelectedProjectOptions([]);
    setSelectedTeamOptions([]);
    setSelectedComponentOptions([]);
    setSelectedPriorityOptions([]);
    setSelectedAssigneeOptions([]);
    setSelectedStatusOptions([]);
    setSelectedApprovalStatusOptions([]);
    setSelectedCustomerOptions([]);
    setSelectedVendorOptions([]);
    setIsChecked(false);
    document.getElementById("from_date").value = "";
    document.getElementById("to_date").value = "";
  };

  const exportQuickGet = async (option) => {
    const response = await exportquickApi(
      option.value,
      formattedFromDate,
      formattedToDate,
      isChecked
    );
    setSnackbarMessage(response.data.message);
    setSnackbarStatus(response.data.success);
    handleSnackbarShow();
    if (response.status === 200) {
      if (response.data.success === true) {
        const base64String = response.data.base64; // Truncated for brevity
        const fileName = response.data.file_name;

        // Convert Base64 to Blob
        downloadBase64File(base64String, fileName);
      }
    }
  };
  const getExcel = async (filterType) => {
    try {
      const reportTypeValue = document.getElementById("report_type")?.value;
      const assignStatusValue = document.getElementById("assign_status")?.value;
      const fromDateValue = document.getElementById("from_date")?.value || formattedFromDate || "";
      const toDateValue = document.getElementById("to_date")?.value || formattedToDate || "";

      const requestBody = {
        report_type: reportTypeValue || "tickets",
        ...(assignStatusValue ? { assign_status: assignStatusValue } : {}),
        approval_status: selectedApprovalStatusOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        project_id: selectedProjectOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        vendor_id: selectedVendorOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        team_id: selectedTeamOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        component_id: selectedComponentOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        priority: selectedPriorityOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        assignee_id: selectedAssigneeOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        status: selectedStatusOptions
          .filter((item) => item.value !== "")
          .map((item) => item.value),
        expected_date: Boolean(isChecked),
        customer_assigned: isCustomerChecked,
        vendor_assigned: isVendorChecked,
        from_date: fromDateValue,
        to_date: toDateValue,
        data_filter: filterType || "",
      };

      var endUrl = "report";
      if (selectedType === "Project") {
        endUrl = "project_report";
      } else if (selectedType === "Component") {
        endUrl = "component_report";
      } else if (selectedType === "Team") {
        endUrl = "team_report";
      } else if (selectedType === "Location") {
        endUrl = "location_report";
      } else if (selectedType === "Region") {
        endUrl = "region_report";
      }

      const response = await apiCall("post", endUrl, requestBody);
      if (response?.status === 200 && response.data?.success === true) {
        const fileName = response.data.file_name || `${selectedType}_Report_${new Date().getTime()}.xlsx`;

        if (response.data.base64) {
          const base64String = response.data.base64;
          const binary = atob(base64String);
          const array = [];
          for (let i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          const blob = new Blob([new Uint8Array(array)], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else if (response.data.download_url || response.data.url) {
          const link = document.createElement("a");
          link.href = response.data.download_url || response.data.url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    } catch (err) {
      console.error("Export Excel Error:", err);
      setSnackbarMessage("Something went wrong");
      setSnackbarStatus(false);
      handleSnackbarShow();
    }
  };

  const handleExport = (filterType) => {
    /*  const fileUrl = excel;

    // Create a hidden anchor element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "Report.xlsx"; // Suggested filename (optional)
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up
    document.body.removeChild(link); */

    getExcel(filterType);
  };

  useEffect(() => {
    getProject("");
    getModule();
    getComponent();
    getSubcomponent();
    getTeam();
    getQuickReport();
    getEmployee();
  }, []);

  const getProject = async (searchTerm) => {
    const response = await apiCall("get", "get_project", null, {
      params: { term: searchTerm ?? "" },
    });
    const options = (response?.data?.suggestionlist ?? []).map((item) => ({
      value: String(item.value),
      label: String(item.label),
    }));
    setProjectlist(options);
  };
  const handleProjectDropdownChange = (selectedOptions) => {
    console.log(selectedOptions);
    const index = selectedProjectOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    console.log(selectedProjectOptions);
    if (index > -1) {
      const updatedOptions = selectedProjectOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedProjectOptions(updatedOptions);
    } else {
      setSelectedProjectOptions([...selectedProjectOptions, selectedOptions]);
    }
  };

  const handleTeamDropdownChange = (selectedOptions) => {
    const index = selectedTeamOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedTeamOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedTeamOptions(updatedOptions);
    } else {
      setSelectedTeamOptions([...selectedTeamOptions, selectedOptions]);
    }
  };

  const handleComponentDropdownChange = (selectedOptions) => {
    const index = selectedComponentOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedComponentOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedComponentOptions(updatedOptions);
    } else {
      setSelectedComponentOptions([
        ...selectedComponentOptions,
        selectedOptions,
      ]);
    }
  };

  const handlePriorityDropdownChange = (selectedOptions) => {
    const index = selectedPriorityOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedPriorityOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedPriorityOptions(updatedOptions);
    } else {
      setSelectedPriorityOptions([...selectedPriorityOptions, selectedOptions]);
    }
  };

  const handleAssigneeDropdownChange = (selectedOptions) => {
    const index = selectedAssigneeOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedAssigneeOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedAssigneeOptions(updatedOptions);
    } else {
      setSelectedAssigneeOptions([...selectedAssigneeOptions, selectedOptions]);
    }
  };

  const handleStatusDropdownChange = (selectedOptions) => {
    const index = selectedStatusOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedStatusOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedStatusOptions(updatedOptions);
    } else {
      setSelectedStatusOptions([...selectedStatusOptions, selectedOptions]);
    }
  };

  const handleApprovalStatusDropdownChange = (selectedOptions) => {
    const index = selectedApprovalStatusOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedApprovalStatusOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedApprovalStatusOptions(updatedOptions);
    } else {
      setSelectedApprovalStatusOptions([
        ...selectedApprovalStatusOptions,
        selectedOptions,
      ]);
    }
  };

  const handleCustomerDropdownChange = (selectedOptions) => {
    const index = selectedCustomerOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedCustomerOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedCustomerOptions(updatedOptions);
    } else {
      setSelectedCustomerOptions([...selectedCustomerOptions, selectedOptions]);
    }
  };

  const handleVendorDropdownChange = (selectedOptions) => {
    const index = selectedVendorOptions.findIndex(
      (option) => option.value === selectedOptions.value
    );
    if (index > -1) {
      const updatedOptions = selectedVendorOptions.filter(
        (option) => option.value !== selectedOptions.value
      );
      setSelectedVendorOptions(updatedOptions);
    } else {
      setSelectedVendorOptions([...selectedVendorOptions, selectedOptions]);
    }
  };

  const getModule = async () => {
    const response = await apiCall("get", "get_module");
    setModulelist(response?.data?.suggestionlist ?? []);
  };

  const getComponent = async () => {
    const response = await apiCall("get", "get_component", null, {
      params: { project_id: "" },
    });
    setComponentlist(response?.data?.suggestionlist ?? []);
  };

  const getSubcomponent = async () => {
    const response = await apiCall("get", "get_subcomponent");
    setSubcomponentlist(response?.data?.suggestionlist ?? []);
  };

  const getTeam = async () => {
    const response = await apiCall("get", "get_team");
    setTeamlist(response?.data?.suggestionlist ?? []);
  };
  const getQuickReport = async () => {
    const response = await getquickreportApi();
    if (response && response.success === true) {
      setQuickReportList(response.suggestionlist ?? []);
    } else {
      setQuickReportList([]);
    }
  };

  const getEmployee = async () => {
    const response = await apiCallAdmin("get", "get_employee");
    setEmplist(response?.data?.suggestionlist ?? []);
  };

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflowY: "auto", // only vertical scroll
            overflowX: "hidden", // hide horizontal scroll
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            <div
              /* className="maincontent3" */ style={{ marginBottom: "32px" }}
            >
              <div
                style={{
                  /* width: "1171px", */
                  /* top: "72px",
                left: "253px", */
                  borderRadius: "16px",
                  padding: "32px",
                  gap: "24px",
                  backgroundColor: "#FFFFFF",
                  margin: "16px",
                }}
              >
                <Row className="align-items-center">
                  {/* Left Column */}
                  <Col sm={12} md={8}>
                    <div style={{ width: "100%", marginTop: "16px" }}>
                      <div style={{ height: "18px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "700",
                            fontSize: "24px",
                            lineHeight: "22px",
                            color: "#212129",
                          }}
                        >
                          {selectedReportType === "QuickReport"
                            ? "Quick Report Download"
                            : "Customize your export"}
                        </span>
                      </div>
                      <div style={{ marginTop: "20px" }}>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#8790A1",
                          }}
                        >
                          {selectedReportType === "QuickReport" ? (
                            <>
                              Quickly create and save comprehensive reports in
                              just moments. One click is all it takes to access
                              the information
                              <br />
                              you need, whenever you need it!
                            </>
                          ) : (
                            <>
                              Use this customized export option to get your data
                              with your applied filters and manage them <br />{" "}
                              easily. Exporting data helps in creating backups.
                            </>
                          )}
                        </span>
                      </div>{" "}
                      <div className="report-inner-content mt-3">
                        <Row className="align-items-center">
                          {/* Left side - report type */}
                          <Col sm={12} md={4} lg={4}>
                            <div className="report-type">
                              <div
                                onClick={() =>
                                  setSelectedReportType("QuickReport")
                                }
                                className={`report-type-option ${
                                  selectedReportType === "QuickReport"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Quick report
                              </div>
                              <div
                                onClick={() =>
                                  setSelectedReportType("Customized")
                                }
                                className={`report-type-option ${
                                  selectedReportType === "Customized"
                                    ? "active"
                                    : ""
                                }`}
                              >
                                Customized
                              </div>
                            </div>
                          </Col>

                          {/* Spacer column */}
                          <Col />

                          {/* Right side - date range */}
                          <Col
                            sm={12}
                            md={4}
                            lg={4}
                            className="d-flex justify-content-end"
                          >
                            {/* <div className="d-flex justify-content-end mb-2 flex-wrap">
                      <div className="d-flex align-items-center gap-2">
                        <div
                          style={{
                            fontWeight: "500",
                            fontSize: "12px",
                            color: "#172b4d",
                          }}
                          className="d-none d-xl-block"
                        >
                          Date range :
                        </div>
                        <div>
                          <DatePicker
                            selected={reportStartDate}
                            onChange={handleDatesChange}
                            startDate={reportStartDate}
                            endDate={reportEndDate}
                            selectsRange
                            placeholderText="Select date range"
                            className="form-control rounded-3 custom-datepicker"
                            style={{
                              backgroundColor: "#F8F8F8",
                              color: "#8790A1",
                              cursor: "pointer",
                            }}
                          />
                        </div>
                        {reportStartDate && reportEndDate && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={handleDateClear}
                          >
                            <SlotCloseIcon />
                          </div>
                        )}
                      </div>
                    </div> */}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>

                  {/* Right Column (Image) */}
                  <Col sm={12} md={4} className="text-center">
                    <div
                      style={{
                        // width: "120px",
                        height: "220px",

                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "0 auto",
                      }}
                    >
                      <img src={img} alt="" style={{ height: "220px" }} />
                    </div>
                  </Col>
                </Row>

                {selectedReportType === "Customized" && (
                  <div>
                    <div /* style={{ width: "1107px", gap: "16px" }} */>
                      <Row
                        xs={12}
                        style={{ display: "flex", flexWrap: "wrap" }}
                      >
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Type
                          </h1>
                          <select
                            className="w-100"
                            style={{
                              /*  width: "264.75px", */
                              height: "40px",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 16px",
                              gap: "77px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                            value={selectedType}
                            onChange={(e) => setSelectedType(e.target.value)}
                          >
                            {/* <option value="">Select</option> */}
                            <option value="All">All</option>
                            <option value="Project">Project</option>
                            <option value="Component">Component</option>
                            <option value="Team">Team</option>
                            <option value="Location">Location</option>
                            <option value="Region">Region</option>
                          </select>
                        </Col>

                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Report Type
                          </h1>

                          <select
                            className="w-100"
                            id="report_type"
                            style={{
                              height: "40px",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 16px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                          >
                            <option value="">Select</option>
                            {reportTypes.map((type, index) => (
                              <option key={index} value={type.value}>
                                {type.label}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Assigned Status
                          </h1>

                          <select
                            className="w-100"
                            id="assign_status"
                            style={{
                              height: "40px",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 16px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                          >
                            <option value="">Select</option>
                            {assignedList.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select>
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Approval Status
                          </h1>

                          {/* <select
                            className="w-100"
                            id="approval_status"
                            style={{
                              height: "40px",
                              fontFamily: "Satoshi",
                              fontSize: "14px",
                              fontWeight: "500",
                              lineHeight: "18.9px",
                              color: "#8790A1",
                              border: "0.7px solid #E5E5E5",
                              padding: "0 16px",
                              backgroundColor: "#FFFFFF",
                              borderRadius: "10px",
                            }}
                          >
                            <option value="">Select</option>
                            {approvalList.map((item, index) => (
                              <option key={index} value={item.value}>
                                {item.label}
                              </option>
                            ))}
                          </select> */}
                          <MultiSelectDropDown
                            staticOptions={approvalList}
                            onDropdownChange={
                              handleApprovalStatusDropdownChange
                            }
                            apiUrl={""}
                            placeholder={"Approval Status"}
                            selectedOption={selectedApprovalStatusOptions}
                          />
                        </Col>
                        {/* )} */}

                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Project Name
                          </h1>
                          <MultiSelectDropDown
                            onDropdownChange={handleProjectDropdownChange}
                            apiUrl={apiUrl + `get_project`}
                            placeholder={"Project"}
                            selectedOption={selectedProjectOptions}
                          />
                          {/*  <Select className="w-100" 
        isMulti
        options={projectlist}
        value={selectedProjectOptions}
        onChange={handleChange}
        isSearchable={true}
        onInputChange={(searchTerm) => getProject(searchTerm)}
        
        placeholder="Search and select users..."
      /> */}
                          {/*  <select className="w-100" id="project_id"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {projectlist.map((project, index) => (
                          <option key={index} value={project.value}>
                            {project.label}
                          </option>
                        ))}
                      </select> */}
                        </Col>
                        {/* )} */}

                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Team
                          </h1>
                          {/*  <select className="w-100" id="team_id"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {teamlist.map((team, index) => (
                          <option key={index} value={team.value}>
                            {team.label}
                          </option>
                        ))}
                      </select> */}
                          <MultiSelectDropDown
                            onDropdownChange={handleTeamDropdownChange}
                            apiUrl={apiUrl + `get_team`}
                            placeholder={"Team"}
                            selectedOption={selectedTeamOptions}
                          />
                        </Col>
                        {/* )} */}

                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Component
                          </h1>
                          <MultiSelectDropDown
                            onDropdownChange={handleComponentDropdownChange}
                            apiUrl={apiUrl + `get_component`}
                            placeholder={"Component"}
                            selectedOption={selectedComponentOptions}
                          />
                          {/* <select className="w-100" id="component_id"
                        style={{
                        
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {componentlist.map((component, index) => (
                          <option key={index} value={component.value}>
                            {component.label}
                          </option>
                        ))}
                      </select> */}
                        </Col>
                        {/* )} */}
                        {/* {selectedType === "1" && ( */}
                        {/* <Col sm={12} md={6} lg={4} style={{marginTop:'16px'}}>
                      <h1
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                        }}
                      >
                        Sub Component
                      </h1>
                      <select className="w-100" id="sub_component_id"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {subcomponentlist.map((subcomponent, index) => (
                          <option key={index} value={subcomponent.value}>
                            {subcomponent.label}
                          </option>
                        ))}
                      </select>
                    </Col> */}
                        {/* )} */}
                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Priority
                          </h1>
                          <MultiSelectDropDown
                            staticOptions={priorityList}
                            onDropdownChange={handlePriorityDropdownChange}
                            apiUrl={""}
                            placeholder={"Priority"}
                            selectedOption={selectedPriorityOptions}
                          />
                          {/* <select className="w-100" id="priority"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select> */}
                        </Col>
                        {/* )} */}
                        {/* {selectedType === "1" && ( */}
                        {/*  <Col sm={12} md={6} lg={4} style={{marginTop:'16px'}}>
                      <h1
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                        }}
                      >
                        Module
                      </h1>
                      <select className="w-100" id="module_id"
                        style={{
                          
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {modulelist.map((module, index) => (
                          <option key={index} value={module.value}>
                            {module.label}
                          </option>
                        ))}
                      </select>
                    </Col> */}
                        {/* )} */}

                        {/* {selectedType === "1" && ( */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Username
                          </h1>
                          <MultiSelectDropDown
                            onDropdownChange={handleAssigneeDropdownChange}
                            apiUrl={accountsUrl + `get_employee`}
                            placeholder={"Assignee"}
                            selectedOption={selectedAssigneeOptions}
                          />
                          {/*  <select className="w-100" id="assignee_id"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        {emplist.map((employee, index) => (
                          <option key={index} value={employee.value}>
                            {employee.label}
                          </option>
                        ))}
                      </select> */}
                        </Col>
                        {/* )} */}

                        {/* {selectedType === "1" && ( */}
                        {/* )} */}
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Customer
                          </h1>
                          <MultiSelectDropDown
                            onDropdownChange={handleCustomerDropdownChange}
                            apiUrl={apiUrl + `get_client`}
                            placeholder={"Customer"}
                            selectedOption={selectedCustomerOptions}
                          />
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Vendor
                          </h1>
                          <MultiSelectDropDown
                            onDropdownChange={handleVendorDropdownChange}
                            apiUrl={apiUrl + `get_vendor`}
                            placeholder={"Vendor"}
                            selectedOption={selectedVendorOptions}
                          
                          />
                        </Col>
                        <Col
                          sm={12}
                          md={6}
                          lg={4}
                          style={{ marginTop: "16px" }}
                        >
                          <h1
                            style={{
                              fontFamily: "Satoshi",
                              fontWeight: "500",
                              fontSize: "13px",
                              lineHeight: "17.55px",
                              color: "#212129",
                            }}
                          >
                            Status
                          </h1>
                          <MultiSelectDropDown
                            staticOptions={statusList}
                            onDropdownChange={handleStatusDropdownChange}
                            apiUrl={""}
                            placeholder={"Status"}
                            selectedOption={selectedStatusOptions}
                          />
                          {/*  <select className="w-100" id="status"
                        style={{
                         
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          gap: "77px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="Open">Open</option>
                        <option value="InProgress">InProgress</option>
                        <option value="Hold">Hold</option>
                        <option value="Closed">Closed</option>
                        <option value="Completed">Completed</option>
                      </select> */}
                        </Col>
                      </Row>
                    </div>
                    <Row>
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <input
                          type="checkbox"
                          id="customer"
                          onClick={handleCustomerCheckBox}
                          checked={isCustomerChecked}
                        />{" "}
                        Customer assigned
                      </Col>
                      <Col sm={12} md={6} lg={4} style={{ marginTop: "16px" }}>
                        <input
                          type="checkbox"
                          id="vendor"
                          onClick={handleVendorCheckBox}
                          checked={isVendorChecked}
                        />{" "}
                        Vendor assigned
                      </Col>
                    </Row>
                    <Row xs={12} style={{ marginTop: "16px" }}>
                      {/* {selectedType === "1" && ( */}
                      <Col sm={12} lg={8}>
                        <div
                          style={{
                            display: "flex",
                            borderRadius: "16px",
                            gap: "16px",
                            backgroundColor: "#F5EFFF",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "16px",
                            }}
                          >
                            <div>
                              <input
                                type="checkbox"
                                id="expected_date"
                                onClick={handleCheckboxChange}
                                checked={isChecked}
                              />
                            </div>

                            <div>
                              <h1
                                style={{
                                  fontFamily: "Satoshi",
                                  fontWeight: "500",
                                  fontSize: "13px",
                                  lineHeight: "17.55px",
                                  color: "#212129",
                                  textAlign: "center",
                                }}
                              >
                                Expected date filter
                              </h1>
                            </div>
                          </div>
                          <div
                            style={{
                              width: "0px",
                              height: "102px",
                              border: "1px solid #D8D3DF",
                              marginBottom: "16px",
                            }}
                          ></div>

                          <div style={{ paddingTop: "16px" }}>
                            <h1
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                              }}
                            >
                              From Date
                            </h1>
                            <input
                              id="from_date"
                              type="date"
                              style={{
                                height: "40px",
                                borderRadius: "10px",
                                border: "0.7px solid #E5E5E5",
                                padding: "16px",
                              }}
                              class="date-picker"
                              placeholder="DD-MM-YYYY"
                            />
                          </div>

                          <div
                            style={{ paddingTop: "16px", paddingRight: "16px" }}
                          >
                            <h1
                              style={{
                                fontFamily: "Satoshi",
                                fontWeight: "500",
                                fontSize: "13px",
                                lineHeight: "17.55px",
                                color: "#212129",
                              }}
                            >
                              To Date
                            </h1>
                            <input
                              id="to_date"
                              type="date"
                              placeholder="DD-MM-YYYY"
                              style={{
                                height: "40px",
                                borderRadius: "10px",
                                border: "0.7px solid #E5E5E5",
                                padding: "16px",
                              }}
                            />
                          </div>
                        </div>
                      </Col>
                      {/* )} */}

                      {/* {selectedType === "1" && ( */}
                      <Col sm={12} lg={4}>
                        <div
                          style={{
                            display: "flex",
                            paddingTop: "60px",
                            justifyContent: "end",
                            alignItems: "center",
                          }}
                        >
                          <button
                            style={{
                              width: "126px",
                              height: "44px",
                              borderRadius: "8px",
                              border: "0.6px solid #E5E5E5",
                              padding: "13px 44px 13px 44px",
                              gap: "8px",
                              backgroundColor: "#FFFFFF",
                              margin: "0",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textDecoration: "none",
                            }}
                            onClick={handleReset}
                          >
                            <p style={{ margin: "0" }}>Reset</p>
                          </button>

                          {/* <button
                            style={{
                              width: "126px",
                              height: "44px",
                              borderRadius: "8px",
                              color: "#FFFFFF",
                              border: "0.6px solid #E5E5E5",
                              padding: "13px 44px 13px 44px",
                              gap: "8px",
                              backgroundColor: "#6929E2",
                              marginLeft: "8px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              textDecoration: "none",
                            }}
                            onClick={handleExport}
                          >
                            <p style={{ margin: "0" }}>Export</p>
                          </button> */}
                          <DropdownButton
                            id="dropdown-basic-button"
                            title="Export"
                            className="export-dropdown-btn"
                          >
                            {filterTypes.map((item) => {
                              return (
                                <Dropdown.Item
                                  onClick={() => handleExport(item.value)}
                                >
                                  {item.label ?? ""}
                                </Dropdown.Item>
                              );
                            })}
                          </DropdownButton>
                        </div>
                      </Col>
                      {/* )} */}
                    </Row>
                  </div>
                )}
                {selectedReportType === "QuickReport" && (
                  <div>
                    <div className="dotted-divider">
                      <span className="divider-text">
                        Just a single click is enough!
                      </span>
                    </div>
                    {/* Row 1 - Date range on right */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                        flexWrap: "wrap",
                        gap: "16px",
                        marginBottom: "16px",
                      }}
                    >
                      {/* Date Range */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                          flexWrap: "wrap",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "500",
                            fontSize: "14px",
                            color: "#172b4d",
                          }}
                        >
                          Date range:
                        </span>
                        <DatePicker
                          selected={reportStartDate}
                          onChange={handleDatesChange}
                          startDate={reportStartDate}
                          endDate={reportEndDate}
                          selectsRange
                          placeholderText="Select date range"
                          className="form-control rounded-3 custom-datepicker"
                          style={{
                            backgroundColor: "#F8F8F8",
                            color: "#8790A1",
                            cursor: "pointer",
                          }}
                        />
                        {reportStartDate && reportEndDate && (
                          <div
                            style={{ cursor: "pointer" }}
                            onClick={handleDateClear}
                          >
                            <SlotCloseIcon />
                          </div>
                        )}
                      </div>

                      {/* Expected Date Filter */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="expected_date"
                          onClick={handleCheckboxChange}
                          checked={isChecked}
                          style={{
                            width: "16px",
                            height: "16px",
                            cursor: "pointer",
                          }}
                        />
                        <label
                          htmlFor="expected_date"
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "500",
                            fontSize: "13px",
                            lineHeight: "17.55px",
                            color: "#212129",
                            cursor: "pointer",
                          }}
                        >
                          Expected date filter
                        </label>
                      </div>
                    </div>
                    {/* Row 2 - Quick report list */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "12px",
                        marginBottom: "24px",
                      }}
                    >
                      {quickReportList.map((item, index) => (
                        <div
                          onClick={() => exportQuickGet(item)}
                          key={index}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            gap: "12px",
                            alignItems: "center",
                            borderRadius: "16px",
                            padding: "12px",
                            border: "0.7px solid #F8F8F8",
                            backgroundColor: "#F8F8F8",
                            width: "calc(25% - 9px)", // 4 per row
                            boxSizing: "border-box",
                          }}
                        >
                          {" "}
                          <div>
                            <img
                              src={getIconByLabel(item.label)}
                              style={{
                                width: ["Monthly Report", "Weekly Report", "Location Based", "Reporter Based", "Assignee Based"].includes(item.label) ? "18px" : "24px",
                                height: ["Monthly Report", "Weekly Report", "Location Based", "Reporter Based", "Assignee Based"].includes(item.label) ? "18px" : "24px",
                                objectFit: "contain",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              fontWeight: "500",
                              fontSize: "15px",
                              color: "#172B4D",
                            }}
                          >
                            {item.label}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                  <strong className="mr-auto">Snackbar Title</strong>
                </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default Ticketlist;
